module.exports = __webpack_public_path__ + "fonts/SourceSansPro-Italic.3d7cb865.ttf";